/**
 * BOPS-431 to BOPS-435 — the billing blocker alerts. Each one shows an info icon in the Closeout
 * Alerts table, and its popover says what to fix in the ticket's own words, instead of the redirect
 * link every Error alert gets. The alerts API carries no blocker flag, so the keys are listed here,
 * as frontend-portal's Month-End Tasks Settings does (BOPS-436).
 */
export const BILLING_BLOCKER_GUIDANCE: Readonly<Record<string, string>> = {
  //  BOPS-432
  DAILY_NOTE_MISSING_PAYER:
    "This note has no active payer on the date of service. Add or extend the patient's payer coverage to include this date.",
  //  BOPS-433
  DAILY_NOTE_OUTSIDE_CERTIFICATION_PERIOD:
    "This note's date of service is outside the patient's certification or treatment program. Check the certification and treatment program dates.",
  //  BOPS-434
  DAILY_NOTE_OVERLAPPING_PAYERS:
    "This note falls on a date covered by two payers. Adjust the payer dates so they don't overlap.",
  DAILY_NOTE_OVERLAPPING_TREATMENT_PROGRAMS:
    "This note falls on a date covered by two treatment programs. Adjust the treatment program dates so they don't overlap.",
  //  BOPS-435
  PRIMARY_DIAGNOSIS_MISSING_ONSET_DATE:
    'The primary diagnosis for this treatment program has no onset date. Add an onset date.',
};

/** The guidance for a billing blocker alert, or `null` for any other alert. */
export const billingBlockerGuidance = (key: unknown): string | null =>
  typeof key === 'string' && Object.prototype.hasOwnProperty.call(BILLING_BLOCKER_GUIDANCE, key)
    ? BILLING_BLOCKER_GUIDANCE[key]
    : null;

const DISCIPLINES = ['PT', 'OT', 'SLP'];

/**
 * BOPS-432 — the Document column names the note's discipline ("Daily Soap Note Reform PT"), the way
 * an evaluation already reads "Evaluation Reform PT". Daily-note document types carry no discipline,
 * so it comes from the alert's own `discipline`. A label that already names a discipline is left alone.
 */
export const withDiscipline = (label: string, discipline: unknown): string => {
  if (typeof discipline !== 'string' || !DISCIPLINES.includes(discipline)) return label;
  if (DISCIPLINES.some((known) => label.endsWith(` ${known}`))) return label;
  return `${label} ${discipline}`;
};
